import { DateTime, Info } from 'luxon';
import { forwardRef, useContext, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { default as ReactSelect } from 'react-select';
import '../../../../node_modules/react-datepicker/dist/react-datepicker.css';
import { FeatureContext } from '../../../Context';
import { lang, useBfGlobals } from '../../../Utils';

const Filters = () => {

  const globals = useBfGlobals();

  const context = useContext(FeatureContext);
  const [years, setYears] = useState();

  const DatePickerButton = forwardRef(({ value, onClick }, ref) => (
    <button className="bf-btn-filters" onClick={onClick} ref={ref}>
      {value}
    </button>));

  const getOrdersStatus = () => context?.orders?.filters?.status
    .map((value) => ({ ...value, label: lang(value.label) }))
    .sort((a, b) => (a.label < b.label) ? -1 : ((a.label > b.label) ? 1 : 0));

  const getValueLabel = (list) => (!!list) ? list
    .map((value) => ({ value: value, label: lang(value) }))
    .sort((a, b) => (a.label < b.label) ? -1 : ((a.label > b.label) ? 1 : 0)) : [];

  const getStartDate = () => DateTime.fromISO(context.filters?.startDate).toJSDate();
  const getEndDate = () => DateTime.fromISO(context.filters?.endDate).toJSDate();

  const changeStartDate = (date) => {
    context.setFiltersDate('startDate', date);
    const diff = DateTime.fromISO(context.filters?.endDate).diff(DateTime.fromJSDate(date), 'years').toObject();
    if (diff?.years < 0 || diff?.years > 1) {
      context.setFiltersDate('endDate', DateTime.fromJSDate(date).plus({ days: 364 }).toJSDate());
    }
  }

  const changeEndDate = (date) => {
    context.setFiltersDate('endDate', date);
    const diff = DateTime.fromISO(context.filters?.endDate).diff(DateTime.fromJSDate(date), 'years').toObject();
    if (diff?.years < 0 || diff?.years > 1) {
      context.setFiltersDate('startDate', DateTime.fromJSDate(date).plus({ days: -364 }).toJSDate());
    }
  }

  const getDateFormat = () => (globals.get('locale') === 'it_IT') ? 'dd/MM/yyyy' : 'MM/dd/yyyy';

  const renderDatePickerSelector = ({
    date,
    monthDate,
    customHeaderCount,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
  }) => (
    <div>
      <button
        aria-label="Previous Month"
        className={
          "react-datepicker__navigation react-datepicker__navigation--previous"
        }
        style={customHeaderCount === 1 ? { visibility: "hidden" } : null}
        onClick={decreaseMonth}
      >
        <span
          className={
            "react-datepicker__navigation-icon react-datepicker__navigation-icon--previous"
          }
        >
          {"<"}
        </span>
      </button>
      <select
        value={date?.getMonth()}
        onChange={({ target: { value } }) => changeMonth(value)}>
        {Info.months('long').map((option, index) => (
          <option key={option} value={index}>
            {option}
          </option>
        ))}
      </select>
      <select
        value={date?.getFullYear()}
        onChange={({ target: { value } }) => changeYear(value)}>
        {years.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <button
        aria-label="Next Month"
        className={
          "react-datepicker__navigation react-datepicker__navigation--next"
        }
        onClick={increaseMonth}
      >
        <span
          className={
            "react-datepicker__navigation-icon react-datepicker__navigation-icon--next"
          }
        >
          {">"}
        </span>
      </button>
    </div>
  )

  useEffect(() => {
    const arr = [];
    for (let i = DateTime.now().plus({ year: -10 }).year; i <= DateTime.now().plus({ year: 10 }).year; i++) {
      arr.push(i);
    }
    setYears(arr);
  }, []);
  return (
    <div className='bf-filters'>
      <div className="bf-filters-group">
        <label>{lang('Start Date')}</label>
        <DatePicker
          dateFormat={getDateFormat()}
          renderCustomHeader={renderDatePickerSelector}
          maxDate={getEndDate()}
          selected={getStartDate()}
          onChange={changeStartDate} 
          customInput={<DatePickerButton />}/>
      </div>
      <div className="bf-filters-group">
        <label>{lang('End Date')}</label>
        <DatePicker
          dateFormat={getDateFormat()}
          renderCustomHeader={renderDatePickerSelector}
          minDate={getStartDate()}
          selected={getEndDate()}
          onChange={changeEndDate} 
          customInput={<DatePickerButton />} />
      </div>
      <div className="bf-filters-group">
        <label>{lang('Status')}</label>
        <ReactSelect
          classNamePrefix="bf-select"
          value={context.filters?.status}
          onChange={(values) => context.setFilters('status', values)}
          closeMenuOnSelect={false}
          isMulti
          options={getOrdersStatus()} />
      </div>
      <div className="bf-filters-group">
        <label>{lang('Sales Order Number')}</label>
        <ReactSelect
          classNamePrefix="bf-select"
          value={context.filters?.salesOrderNumber}
          onChange={(values) => context.setFilters('salesOrderNumber', values)}
          closeMenuOnSelect={false}
          isMulti
          options={getValueLabel(context?.orders?.filters?.salesOrderNumber)} />
      </div>
      <div className="bf-filters-group">
        <label>{lang('Purchase Order Number')}</label>
        <ReactSelect
          classNamePrefix="bf-select"
          value={context.filters?.purchaseOrderNumber}
          onChange={(values) => context.setFilters('purchaseOrderNumber', values)}
          closeMenuOnSelect={false}
          isMulti
          options={getValueLabel(context?.orders?.filters?.purchaseOrderNumber)} />
      </div>
    </div>
  );
}

export default Filters;